import {
  FiChevronDown,
  FiClock,
  FiGitBranch,
  FiMove,
} from "react-icons/fi";
import { PiMagicWand } from "react-icons/pi";
import { usePersistentLayoutDisclosure } from "./LayoutDisclosureContext";
import DisclosureMotion from "./DisclosureMotion";
import "./LayoutDisclosure.css";

const DISCLOSURE_ICONS = {
  "quick presets": PiMagicWand,
  structure: FiGitBranch,
  spacing: FiMove,
  "end behavior": FiClock,
};

export default function LayoutDisclosure({ title, children }) {
  const [isExpanded, setIsExpanded] = usePersistentLayoutDisclosure(
    title.toLowerCase(),
  );
  const SectionIcon = DISCLOSURE_ICONS[title.toLowerCase()];

  return (
    <section className="sx-layout-disclosure">
      <button
        type="button"
        className={`sx-layout-disclosure__trigger${
          isExpanded ? " sx-layout-disclosure__trigger--open" : ""
        }`}
        aria-expanded={isExpanded}
        onClick={() => setIsExpanded((expanded) => !expanded)}
      >
        <span className="sx-layout-disclosure__title">
          {SectionIcon && (
            <SectionIcon
              className="sx-layout-disclosure__icon"
              aria-hidden="true"
            />
          )}
          <span>{title}</span>
        </span>
        <FiChevronDown
          aria-hidden="true"
          className={`sx-layout-disclosure__chevron${
            isExpanded ? " sx-layout-disclosure__chevron--open" : ""
          }`}
        />
      </button>

      <DisclosureMotion
        expanded={isExpanded}
        contentClassName="sx-layout-disclosure__content"
        role="region"
        ariaLabel={`${title} settings`}
      >
        {children}
      </DisclosureMotion>
    </section>
  );
}
